export const ONBOARDING_AI_ALLOCATION = 'ONBOARDING_AI_ALLOCATION'
export const ONBOARDING_SEED_SAMPLE_DATA = 'ONBOARDING_SEED_SAMPLE_DATA'
export const ONBOARDING_GET_DATA = 'ONBOARDING_GET_DATA'
export const ONBOARDING_COMPLETE = 'ONBOARDING_COMPLETE'
export const ONBOARDING_LESSON_PLANNING_TEMPLATE = 'ONBOARDING_LESSON_PLANNING_TEMPLATE'
export const ONBOARDING_STUDENTS_TEMPLATE = 'ONBOARDING_STUDENTS_TEMPLATE'
export const ONBOARDING_TIMETABLE_COUNTRIES = 'ONBOARDING_TIMETABLE_COUNTRIES'
export const ONBOARDING_TIMETABLE_CURRICULA = 'ONBOARDING_TIMETABLE_CURRICULA'
export const ONBOARDING_TIMETABLE_PREFILL = 'ONBOARDING_TIMETABLE_PREFILL'
export const ONBOARDING_TRACK_EVENTS = 'ONBOARDING_TRACK_EVENTS'
export const ONBOARDING_EXTRACT_TEACHERS = 'ONBOARDING_EXTRACT_TEACHERS'
export const ONBOARDING_FILE_PREFILL = 'ONBOARDING_FILE_PREFILL'
